import { render, staticRenderFns } from "./AnubRekhanComponent.vue?vue&type=template&id=88ca1048&"
import script from "./AnubRekhanComponent.vue?vue&type=script&lang=js&"
export * from "./AnubRekhanComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports